/**
 * Populates a template with variables.
 *
 * The variables in the template should be in the format `{# variable #}`.
 * For example, if you have a variable named `foo`, you would use it in the template like this: `{# foo #}`.
 *
 * @param {HTMLTemplateElement} template - The template to populate.
 * @param {Object} variables - An object containing the variables to populate the template with.
 * @returns {DocumentFragment} - The populated template as a DocumentFragment.
 */
export const populateTemplate = (template, variables) => {
    if (!template || !(template instanceof HTMLTemplateElement)) {
        throw new Error('Invalid template element');
    }
    if (typeof variables !== 'object' || variables === null) {
        throw new Error('Invalid variables object');
    }

    const tempDiv = document.createElement('div');
    tempDiv.appendChild(template.content.cloneNode(true));

    tempDiv.innerHTML = tempDiv.innerHTML.replace(
        /{#\s*(.*?)\s*#}/g,
        (match, variableName) => variables[variableName] || ''
    );

    const clone = document.createDocumentFragment();
    while (tempDiv.firstChild) {
        clone.appendChild(tempDiv.firstChild);
    }

    return clone;
};
